export const isAuthenticated = () => {
    if (localStorage.getItem('coachToken')) {
        return localStorage.getItem('coachToken')
    }
    return false
}

export const userRole = () => {
    const token = localStorage.getItem('coachToken')

    if (token) {
        const payload = token.split('.')[1]
        const decoded = JSON.parse(atob(payload))

        return decoded?.role
    } else {
        return null
    }
}
